import type {
  AccountUserProfileBirthSeason,
  AccountUserProfileHoroscope,
} from '../services/accountUserProfileService';

export type HoroscopeMeta = {
  id: AccountUserProfileHoroscope;
  label: string;
  dateRange: string;
  seasons: AccountUserProfileBirthSeason[];
  primarySeason: AccountUserProfileBirthSeason;
};

export const HOROSCOPE_CATALOG: HoroscopeMeta[] = [
  {
    id: 'capricorn',
    label: '摩羯座',
    dateRange: '12/22–1/19',
    seasons: ['winter', 'early_year'],
    primarySeason: 'winter',
  },
  {
    id: 'aquarius',
    label: '水瓶座',
    dateRange: '1/20–2/18',
    seasons: ['early_year'],
    primarySeason: 'early_year',
  },
  {
    id: 'pisces',
    label: '双鱼座',
    dateRange: '2/19–3/20',
    seasons: ['early_year', 'spring'],
    primarySeason: 'early_year',
  },
  {
    id: 'aries',
    label: '白羊座',
    dateRange: '3/21–4/19',
    seasons: ['spring'],
    primarySeason: 'spring',
  },
  {
    id: 'taurus',
    label: '金牛座',
    dateRange: '4/20–5/20',
    seasons: ['spring'],
    primarySeason: 'spring',
  },
  {
    id: 'gemini',
    label: '双子座',
    dateRange: '5/21–6/20',
    seasons: ['spring', 'summer'],
    primarySeason: 'summer',
  },
  {
    id: 'cancer',
    label: '巨蟹座',
    dateRange: '6/21–7/22',
    seasons: ['summer'],
    primarySeason: 'summer',
  },
  {
    id: 'leo',
    label: '狮子座',
    dateRange: '7/23–8/22',
    seasons: ['summer'],
    primarySeason: 'summer',
  },
  {
    id: 'virgo',
    label: '处女座',
    dateRange: '8/23–9/22',
    seasons: ['summer', 'autumn'],
    primarySeason: 'autumn',
  },
  {
    id: 'libra',
    label: '天秤座',
    dateRange: '9/23–10/22',
    seasons: ['autumn'],
    primarySeason: 'autumn',
  },
  {
    id: 'scorpio',
    label: '天蝎座',
    dateRange: '10/23–11/21',
    seasons: ['autumn'],
    primarySeason: 'autumn',
  },
  {
    id: 'sagittarius',
    label: '射手座',
    dateRange: '11/22–12/21',
    seasons: ['autumn', 'winter'],
    primarySeason: 'autumn',
  },
];

const HOROSCOPE_BY_ID = new Map(HOROSCOPE_CATALOG.map((item) => [item.id, item]));

export function getHoroscopeMeta(id: AccountUserProfileHoroscope): HoroscopeMeta | null {
  return HOROSCOPE_BY_ID.get(id) ?? null;
}

export function getAllHoroscopes(): HoroscopeMeta[] {
  return HOROSCOPE_CATALOG;
}

export function getHoroscopesForSeason(season: AccountUserProfileBirthSeason): HoroscopeMeta[] {
  return HOROSCOPE_CATALOG.filter((item) => item.seasons.includes(season));
}

export function inferSeasonFromHoroscope(id: AccountUserProfileHoroscope): AccountUserProfileBirthSeason {
  return getHoroscopeMeta(id)?.primarySeason ?? 'spring';
}
